// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"1a0bd0ef","658":"d951017d","743":"e7102578","801":"111e8327","894":"12740000","895":"31ffff19"}[chunkId] + ".js";
};